import { render, staticRenderFns } from "./FrontendToggler.vue?vue&type=template&id=ca8b4fa6&scoped=true&"
import script from "./FrontendToggler.vue?vue&type=script&lang=js&"
export * from "./FrontendToggler.vue?vue&type=script&lang=js&"
import style0 from "./FrontendToggler.vue?vue&type=style&index=0&id=ca8b4fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b4fa6",
  null
  
)

export default component.exports